import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ num, title, sub }) => (
  <div className="relative mb-14 sm:mb-20">
    <span className="outline-num font-display pointer-events-none absolute -top-10 -left-2 select-none text-[7rem] font-extrabold leading-none sm:-top-16 sm:text-[11rem]">
      {num}
    </span>
    <Reveal className="relative">
      <p className="font-mono2 mb-4 text-xs tracking-[0.3em] text-accent uppercase">
        Chapter {num}
      </p>
      <h2 className="font-display text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {sub && <p className="mt-4 max-w-2xl text-base text-ink4 leading-relaxed">{sub}</p>}
      <div className="mt-8 h-px w-24 bg-amber-500/70" />
    </Reveal>
  </div>
);
